import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StatusCatalogKey } from '@bo-client/shared/status/status.model';
import { DetailAction, DetailHint, DetailLayoutConfig, DetailUser } from './entity-detail-layout-v2.model';

@Component({
  selector: 'app-entity-detail-layout-v2',
  templateUrl: './entity-detail-layout-v2.component.html',
  styleUrls: ['./entity-detail-layout-v2.component.scss']
})
export class EntityDetailLayoutV2Component {
  @Input()
  title: string;

  @Input()
  entityId?: string | number;

  @Input()
  state?: string;

  /** Statuskatalog des Vorgangs für den Statuskopf; ohne Angabe modulübergreifend. */
  @Input()
  statusModule?: StatusCatalogKey;

  @Input()
  currentUser: DetailUser;

  @Input()
  actions: DetailAction[] = [];

  @Input()
  layoutConfig: DetailLayoutConfig = {
    actionButtonsPlacement: 'top'
  };

  @Input()
  loading = false;

  @Input()
  errorMessage?: string;

  @Input()
  errors: any;

  @Input()
  hint?: DetailHint | null;

  /**
   * Steuert, ob Header/Body/Fußbereich gerendert werden können.
   * Wird von den aufrufenden Seiten gesetzt (z. B. basierend auf Model + User).
   */
  @Input()
  hasData = true;

  /**
   * Optionales Meta-Entity für z. B. Anzeige von Erstell-/Änderungsdaten.
   */
  @Input()
  metaEntity?: any;

  @Output()
  actionClicked = new EventEmitter<DetailAction>();

  get actionButtonsPlacement(): 'top' | 'bottom' | 'both' {
    return this.layoutConfig?.actionButtonsPlacement ?? 'top';
  }

  showActionsAt(position: 'top' | 'bottom'): boolean {
    if (!this.actions || this.actions.length === 0) {
      return false;
    }

    if (this.actionButtonsPlacement === 'both') {
      return true;
    }

    return this.actionButtonsPlacement === position;
  }

  onActionClicked(action: DetailAction) {
    this.actionClicked.emit(action);
  }
}
